import IsDataNull from "../../../Template/IsDataNull";
import Table, { ColumnsType } from "antd/es/table";
import ActionColumnButtons from "../ActionColumnButtons/ActionColumnButtons";

const TemplateTableColumn: ColumnsType<any> = [
  {
    title: "Name ",
    key: "templateName",
    dataIndex: "name",
    // sorter: true,
    render: (data) => <IsDataNull data={data} />,
    width: 200,
  },
  {
    title: "Last Accessed ",
    key: "lastAccessed",
    dataIndex: "lastAccessed",
    // sorter: true,
    render: (data) => <IsDataNull data={data} />,
    width: 200,
  },
  // {
  //   title: "Actions ",
  //   key: "",
  //   dataIndex: "templates",
  //   render: (data) => <ActionColumnButtons type="template" />,
  //   width: 100,
  // },
];

function AssignTemplatesTable(props: any) {
  const handleTableSorting = (sorter: any) => {
    const isAscend = (order: string) => {
      if (order === "ascend") {
        return true;
      }

      return false;
    };
  };

  return (
    <div>
      <div
        className="d-flex justify-content-between align-items-center mb-2"
        style={{ visibility: "hidden" }}>
        <button
          className="assign-user button d-flex justify-content-start gap-1"
          onClick={() => console.log("Assign Template")}>
          <span className="material-symbols-outlined">person</span>
          <span>Assign Template</span>
        </button>
      </div>

      <Table
        className="table"
        columns={TemplateTableColumn}
        dataSource={props.data}
        pagination={{
          pageSize: 15,
        }}
        size="small"
      />
    </div>
  );
}

export default AssignTemplatesTable;
